import React, { Component } from 'react';
import Icon from 'components/common/Icon';
import moment from 'moment';
import Calendar from 'lib/Calendar';

export default class MyTripsList extends Component {

  render() {
    const { myTrip, onSelect, drawDivider, showChevron } = this.props;

    if (!myTrip || !myTrip.id) {
      return <div></div>;
    }

    let event;
    let pre_trip_start;
    let bus;
    let pickup;
    let dropoff;

    let displayClass = 'data';
    let itemClass = 'list-item clickable';

    if (myTrip.event_id && myTrip.event_id.length) {
      event = (
        <div key="myTrip-event_id-container" className="subtext">
          <Icon icon="calendar" size="small" className="myTripList-icon" /><span key="myTrip-event" dangerouslySetInnerHTML={{ __html: myTrip.event_id }} />
        </div>
      );
    }

    if (myTrip.pre_trip_start && myTrip.pre_trip_start.length) {
      const timeFormat = Calendar.getTimeMomentFormat();
      const preTripStartString = moment(myTrip.pre_trip_start).format('ddd MMM Do, YYYY @ ' + timeFormat);
      pre_trip_start = (
        <div key="myTrip-pre_trip_start-container" className="subtext">
          <Icon icon="time" size="small" className="myTripList-icon" /><span key="myTrip-pre_trip_start">{preTripStartString}</span>
        </div>
      );
    }

    if (myTrip.bus && myTrip.bus.length) {
      bus = (
        <div key="myTrip-bus-container" className="subtext">
          <Icon icon="vehicle" size="small" className="myTripList-icon" /><span key="myTrip-bus" dangerouslySetInnerHTML={{ __html: myTrip.bus }} />
        </div>
      );
    }

    if (myTrip.pickup && myTrip.pickup.length) {
      pickup = (
        <div key="myTrip-pickup-container" className="subtext">
          <Icon icon="location" size="small" className="myTripList-icon" /><span key="myTrip-pickup" dangerouslySetInnerHTML={{ __html: myTrip.pickup }} />
        </div>
      );
    }

    if (myTrip.dropoff && myTrip.dropoff.length) {
      dropoff = (
        <div key="myTrip-dropoff-container" className="subtext">
          <Icon icon="location" size="small" className="myTripList-icon" /><span key="myTrip-dropoff" dangerouslySetInnerHTML={{ __html: myTrip.dropoff }} />
        </div>
      );
    }
  
    if(!pre_trip_start && !bus && !pickup && !dropoff) {
      itemClass += ' thin';
    }

    /* eslint react/jsx-no-bind: 0 */
    const renderItem = () => (
      <div className={itemClass} onClick={onSelect.bind(null, myTrip)}>
        <div className="inner">
          <div className={displayClass}>
            {myTrip.number}
            {event}
            {pre_trip_start}
            {bus}
            {pickup}
            {dropoff}
          </div>
        </div>

        {showChevron && (
          <Icon icon="arrow" className="link-indicator" />
        )}

        {drawDivider && (
          <div className="divider"></div>
        )}
      </div>
    );

    return (
      <span>
        {renderItem()}
      </span>
    );
  }
}

/* eslint no-console: ["error", { allow: ["info"] }] */
MyTripsList.defaultProps = {
  onSelect: (myTrip) => console.info('My Trip selected', myTrip.number),
};



// WEBPACK FOOTER //
// ./src/app/components/calendar/MyTripsListItem.js